export default "__VITE_ASSET__BeR$5Glx__"